module.exports = __webpack_public_path__ + "static/media/POS_03_B.286110b6.png";